module.exports = window.dnn.nodeModules.ReactDOM;